import {gtag4} from '../../../utilities/analytics/tracking';

export function gaInvoiceIntroPage() {
  gtag4({
    event: 'IdfInvoice_IntroPage',
    action: 'IntroPage',
  });
}
export function gaSelectInvoice(content) {
  gtag4({
    event: 'IdfInvoice_SelectInvoice',
    content,
    action: 'SelectInvoice',
  });
}

export function gaSelectInvoiceContinueButton(content,buttonTxt) {
  gtag4({
    event: 'IdfInvoice_SelectInvoiceContinueButton',
    content,
    action: 'SelectInvoice',
    button:buttonTxt,
  });
}

export function gaInvoiceMailingPage() {
  gtag4({
    event: 'IdfInvoice_MailingPage',
    action: 'MailingPage',
  });
}

export function gaMailingPageContinueButton(selectedMethod,IsPrimaryMailChecked,buttonTxt) {
  gtag4({
    event: 'IdfInvoice_MailingPageContinueButton',
    content: IsPrimaryMailChecked,
    section :selectedMethod,
    action: 'SelectInvoiceContinueButton',
    button: buttonTxt,
  });
}
export function gaInvoiceSuccessPage() {
  gtag4({
    event: 'IdfInvoice_SuccessPage',
    action: 'SuccessPage',
  });
}

export function gaErrorMessagePhoneNumBlockedForMailing() {
  gtag4({
    event: 'IdfInvoice_ErrorMessagePhoneNumBlockedForMailing',
    action: 'ErrorMessagePhoneNumBlockedForMailing',
  });
}

export function gaInvoiceErrorMessageGeneral() {
  gtag4({
    event: 'IdfInvoice_ErrorMessageGeneral',
    action: 'ErrorMessageGeneral',
  });
}

export function gaInvoiceSuccessPageInvoiceNotSent() {
  gtag4({
    event: 'IdfInvoiceSuccessPageInvoiceNotSent',
    action: 'SuccessPageInvoiceNotSent',
  });
}
